import React from "react";
import { connect } from "react-redux";
import {
  saveSuperUnreadMessages,
  setNotificationSoundPlayed,
} from "../../redux/actions";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import ActiveUser from "../../assets/media/analytics_icons/active_user.png";
import UserReviews from "../../assets/media/analytics_icons/user_reviews.png";
import TokenValueEarned from "../../assets/media/analytics_icons/token_value_earned.png";
import TokenValueRedeemed from "../../assets/media/analytics_icons/token_value_redeemed.png";
import PollAnswers from "../../assets/media/analytics_icons/poll_answers.png";
import ForumEngagement from "../../assets/media/analytics_icons/forum_engagement.png";
import UserReferrals from "../../assets/media/analytics_icons/user_referrals.png";
import TokenSpendingMarketplace from "../../assets/media/analytics_icons/token_spending_marketplace.png";

import USFlag from "../../assets/media/circle-us.png";
import UKFlag from "../../assets/media/circle-uk.png";
import EcosystemTrial from "../../assets/media/ecosystem_trial-v.png";
import EcosystemGo from "../../assets/media/ecosystem_go-v.png";

import "./index.css";
import moment from "moment-timezone";

// NOTE: for static purpose

const BrandAnalytics = {
  new_users: {
    icon: ActiveUser,
    text: "Active\nusers",
    value: 0,
  },
  token_value_earned: {
    icon: TokenValueEarned,
    text: "Token value\nearned",
    value: "£0",
  },
  token_value_redeemed: {
    icon: TokenValueRedeemed,
    text: "Token value\nredeemed",
    value: "£0",
  },
  poll_answers: {
    icon: PollAnswers,
    text: "Poll\nanswers",
    value: 0,
  },
  forum_engagement: {
    icon: ForumEngagement,
    text: "Forum\nengagements",
    value: 0,
  },
  user_reviews: {
    icon: UserReviews,
    text: "User\nreviews",
    value: 0,
  },
  user_referrals: {
    icon: UserReferrals,
    text: "User\nreferrals",
    value: 0,
  },
  token_spending_marketplace: {
    icon: TokenSpendingMarketplace,
    text: "Total spending\nin marketplace",
    value: "£0",
  },
};

class SuperAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      brand: {},
      brands: [],
      loading: true,
      brandTab: 0,
      ecoTab: 0,
      selectedBrand: null,
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      Firebase.getAllBrands((res) => {
        let brands = res
          .map((item, index) => {
            let new_item = item;
            new_item.id = index;
            return new_item;
          })
          .filter((item) => item && !item.deactive);
        brands.sort(function (a, b) {
          var textA = a.name.toUpperCase();
          var textB = b.name.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        //get All unread messages from brands
        Firebase.getAllUnReadMessagesSentFromAdmins(
          this.subscribeUnreadMessages
        );
        this.setState({ brands, loading: false });
      });
    }
  }
  subscribeUnreadMessages = (unreads) => {
    let super_unreads = [];
    Object.keys(unreads).forEach((brand_id) => {
      Object.keys(unreads[brand_id]).forEach((ticket_id) => {
        const id = brand_id + "_" + ticket_id;
        super_unreads.push({
          id,
          ...unreads[brand_id][ticket_id],
        });
      });
    });

    // if new unread messages come in, reset notification sound
    super_unreads.length &&
      this.props.dispatch(setNotificationSoundPlayed(false));

    this.props.dispatch(saveSuperUnreadMessages(super_unreads));
  };

  onTabChanged = (name, value) => () => {
    this.setState({
      [name]: value,
    });
  };

  handleChangeBrand = (selectedBrand) => {
    this.setState({ selectedBrand });
  };

  renderItem = (item) => (
    <div className="item-container">
      <img src={item.icon} alt="icon" />
      <p className="item-name">{item.text}</p>
      <p className="item-value">{item.value}</p>
    </div>
  );

  checkToday = (brand) => {
    return (
      !!brand.created_at && moment(brand.created_at).isSame(moment(), "day")
    );
  };

  render() {
    const { username, role, brand, loading, brands } = this.state;
    const ukBrands = brands.filter(
      (obj) =>
        this.checkToday(obj) && (!obj.territory || obj.territory === "UK")
    );
    const usBrands = brands.filter(
      (obj) => this.checkToday(obj) && obj.territory === "USA"
    );
    const testRollOutBrands = brands.filter(
      (obj) => this.checkToday(obj) && obj.salesStage === "Test Roll Out"
    );
    const fullRollOutBrands = brands.filter(
      (obj) => this.checkToday(obj) && obj.salesStage === "Full Roll Out"
    );
    return (
      <div id="page-contaienr">
        <Header
          username={username}
          role={role}
          brand={0}
          logo={brand && brand.logo}
        />
        <main id="main-container">
          <div className="today-snapshot-content">
            {loading && (
              <div className="loading">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
            {!loading && (
              <div className="today-snapshot-container">
                <div className="snapshot-time">
                  <b>The Snapshot</b>
                  <p>London {moment.tz("Europe/London").format("h:mm A")}</p>
                  <p>
                    New York {moment.tz("America/New_York").format("h:mm A")}
                  </p>
                  <p>LA {moment.tz("America/Los_Angeles").format("h:mm A")}</p>
                  <b>{moment().format("dddd MMM Do YYYY")}</b>
                </div>
                <div className="snapshot-info-container">
                  <div className="snapshot-info">
                    <img src={UKFlag} alt="flag" className="flag" />
                    <p className="brand">New UK brand leads</p>
                    <p className="info">{ukBrands.length}</p>
                  </div>
                  <div className="snapshot-info">
                    <img src={USFlag} alt="flag" className="flag" />
                    <p className="brand">New USA brand leads</p>
                    <p className="info">{usBrands.length}</p>
                  </div>
                  <div className="snapshot-info">
                    <img src={EcosystemTrial} alt="flag" className="stage" />
                    <p className="info">{testRollOutBrands.length}</p>
                  </div>
                  <div className="snapshot-info">
                    <img src={EcosystemGo} alt="flag" className="stage" />
                    <p className="info">{fullRollOutBrands.length}</p>
                  </div>
                </div>
                <div className="snapshot-info-container">
                  <div className="snapshot-sm-info">
                    {this.renderItem(BrandAnalytics.new_users)}
                    {this.renderItem(BrandAnalytics.token_value_earned)}
                  </div>
                  <div className="snapshot-sm-info">
                    {this.renderItem(BrandAnalytics.token_value_redeemed)}
                    {this.renderItem(BrandAnalytics.poll_answers)}
                  </div>
                  <div className="snapshot-sm-info">
                    {this.renderItem(BrandAnalytics.forum_engagement)}
                    {this.renderItem(BrandAnalytics.user_reviews)}
                  </div>
                  <div className="snapshot-sm-info">
                    {this.renderItem(BrandAnalytics.user_referrals)}
                    {this.renderItem(BrandAnalytics.token_spending_marketplace)}
                  </div>
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    uid: state.uid,
    users: state.users,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SuperAnalytics);



// WEBPACK FOOTER //
// ./src/screens/TodaySnapshot/index.js